import React, { useEffect } from 'react'
import { result } from 'libraries/lodash'
import { of, concatMap } from 'rxjs'
import { toast } from 'react-toastify'
import ErrorIcon from '@mui/icons-material/Error'
import { isValidResponse } from 'libraries/front-end-core/helpers/dataflow'
import connect from 'libraries/front-end-core/decorators/connect'
import notificationToast from 'helpers/notificationToast'
import {
  getDealParameters,
  requestDeal,
  requestEventConfiguration,
  getDealTimeline,
  requestDealDocument
} from 'services/DealwatchService'
import ResponseConsumer from 'components/shared/ResponseConsumer'
import Forbidden from 'components/shared/Forbidden'
import Details from 'pages/mwdealdetails/Details'
import DocumentOverlay from 'pages/mwdealdetails/document/DocumentOverlay'

const Main = props => {
  const { dealId, query, deal, toggleFullscreenOverlay, documentConfig } = props
  const dealType = documentConfig.eventType.displayName
  const parameters = getDealParameters(deal, documentConfig)
  const timeline = getDealTimeline(deal, documentConfig)

  const document = Object.prototype.hasOwnProperty.call(query, 'docId')
    ? requestDealDocument({ dealId, docId: query.docId })
    : null

  useEffect(() => {
    if (document !== null && query.docId) {
      toggleFullscreenOverlay(<DocumentOverlay pending />)
      document.then(buffer => {
        const param = result(deal, ['params', query.paramName], null)
        const scrollToParam = result(param, 'descriptor.name', '')
        const document = deal.documents[query.docId]
        const otherDocuments = Object.values(deal.documents).filter(({ id }) => id !== query.docId)
        const optionalPath = result(query, 'path')

        toggleFullscreenOverlay(
          <DocumentOverlay {...{
            ...props,
            scrollToParam,
            document,
            otherDocuments,
            optionalPath,
            buffer,
            toggleFullscreenOverlay,
            onBack: toggleFullscreenOverlay(null),
            parameters
          }}
          />
        )
      })
        .catch(error => {
          notificationToast(<ErrorIcon />, toast.TYPE.ERROR, `${error}`, 'bg-indian-red white')
        })
    } else {
      toggleFullscreenOverlay(null)
    }
  }, [query.docId, query.paramName, query.path, document])

  return (
    <Details {...{
      dealType,
      document,
      parameters,
      timeline,
      deal,
      dealId
    }}
    />
  )
}

const ConnectedMain = connect(({ dealId }) => {
  const deal = requestDeal({ dealId })

  return {
    deal,
    documentConfig: deal.pipe(
      concatMap(response => {
        if (isValidResponse(response)) {
          return requestEventConfiguration({ type: response.dealType })
        } else {
          return of(response)
        }
      })
    )
  }
})(props => (
  <ResponseConsumer
    responses={[props.deal, props.documentConfig]}
    unauthorizedComponent={Forbidden}
    content={() => <Main {...props} />}
  />
))

export default ConnectedMain
